import { getReRunResourceReqBody } from "./processResearchQueryResourceData";
import { getQueryParams } from "../../config/runParametersConfig";

/**
 * Processes research query data for execution
 * @param differentResearchQueryData - The research query data
 * @param resourcesData - The resources data
 * @param originalResourcesData - The original resources data for comparison
 * @param resultStorageParameters - The result storage parameters
 * @param runParameters - The run parameters
 * @param inlineVariables - The global variables
 * @param executionName - The execution name
 * @returns The processed payload for research query execution
 */
export const processReRunResearchQueryExecutionData = (
  researchQueryDetailData: any,
  resourcesData: any[],
  resultStorageParameters: any,
  runParameters: any,
  inlineVariables: any,
  executionName: string
): any => {
  try {
    // Process resource data using getResourceReqBody
    let processedResourceData = resourcesData
      .map((resource: any) => {
        // Use the getResourceReqBody function to create a resource object that matches the schema
        let resourceObject: any = getReRunResourceReqBody(resource);

        // Ensure the resource object is not null
        if (!resourceObject) {
          return null;
        }

        return resourceObject;
      })
      .filter(Boolean); // Remove null values

   
    // Create base payload according to the schema
    const basePayload = {
      research_queries: researchQueryDetailData?.research_queries || [],
      resource_data: processedResourceData || [],
      output_storage_params: {
        output_storage_linked_service_id:
          resultStorageParameters?.linked_service_id || null,
        output_storage_linked_service_code:
          resultStorageParameters?.linked_service_code || null,
        output_storage_connection_key:
          resultStorageParameters?.connection_key_id || null,
        output_storage_base_file_path:
          resultStorageParameters?.file_path || null,
      },
      run_instance: {
        run_id: runParameters?.run_instance?.run_id || 1,
        run_name: runParameters?.run_instance?.run_name || "Legacy",
      },
      execution_sub_group: {
        execution_sub_group_id:
          runParameters?.execution_sub_group?.execution_sub_group_id || 0,
        execution_sub_group_code:
          runParameters?.execution_sub_group?.execution_sub_group_code || "",
      },
      query_params: getQueryParams("researchQuery", runParameters),
      inline_variables: inlineVariables ?? {},
      execution_name: executionName ?? "",
    };
    return basePayload;
  } catch (error) {
    console.error("Error processing research query execution data:", error);
    return null;
  }
};
